import * as components from './components'

export default [
  {
    path: '/advancedSearch/course',
    component: components.CourseSearchResults,
    name: 'courseSearchResults',
    props: true
  },
  {
    path: '/advancedSearch/catalog',
    component: components.CatalogSearchResults,
    name: 'catalogSearchResults',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/advancedSearch/routes.js